// extracted by css-extract-rspack-plugin
export default {"cls1":"CoauthorConfirmationCard-cls1_S0F","cls2":"CoauthorConfirmationCard-cls2_ui8 CoauthorConfirmationCard-cls1_S0F"};